const en = {
    message: {
        //
    }
}

export default en



// WEBPACK FOOTER //
// ./src/translations/lang/en.js